import { useQuery } from '@tanstack/react-query';
import { cartViewQueryOptions } from './cart-view-query';
import { EMPTY_CART } from './cart.constants';

const useCart = () => {
    const query = useQuery(cartViewQueryOptions);

    return { ...query, data: query.data ?? EMPTY_CART };
};

export default useCart;
